<template>
  <div class="roleSetting">
    <!-- 设置评价账号弹窗 -->
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="24">
            <div class="handlePanel">
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="addBtnPressed()"
                >新增</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="UsersList"
          highlight-current-row
          size="mini"
          height="100%"
          @current-change="handleSelectionChange"
          @row-click="rowClicked"
          border
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="deptName"
            label="项目部"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="dutyPermissionUserListDisplayString"
            label="主管部门账号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="productPermissionUserListDisplayString"
            label="生产部门账号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="updBtnPressed(scope.row)"
                >修改</el-button
              >
              <el-button
                type="text"
                @click="delBtnPressed(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="ruleForm.pageIndex"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="ruleForm.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 设置账号弹窗 -->
    <el-dialog
      width="600px"
      :title="isAdd ? '新增评价账号' : '修改评价账号'"
      :visible.sync="isAddDialogShow"
      :before-close="closeAddDialog"
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="160px"
        :rules="addRules"
      >
        <el-row>
          <el-col :span="21">
            <el-form-item label="项目部:" prop="projectDeptId">
              <el-select
                v-model="addForm.deptId"
                placeholder="请选择"
                clearable
                filterable=""
                @change="projectDeptChange(addForm.deptId)"
              >
                <el-option
                  v-for="dept in deptList"
                  :key="dept.applyDeptId"
                  :label="dept.applyDeptName"
                  :value="dept.applyDeptId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="生产部门评价账号：">
              <!-- <div class="right add" @click="addClassifyList">选择</div> -->
              <div class="time-box">
                <div class="item">
                  <div class="left">
                    <el-input v-model="productPermissionNames"></el-input>
                  </div>
                  <div class="right add" @click="addClassifyList">修改</div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主管部门评价账号：">
              <!-- <div class="right add" @click="addadminAccountArr">选择</div> -->
              <div class="time-box">
                <div class="item">
                  <div class="left">
                    <el-input v-model="dutyPermissionUserNames"></el-input>
                  </div>
                  <div class="right add" @click="addadminAccountArr">修改</div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeAddDialog">取 消</el-button>
        <el-button type="primary" @click="saveBtnPressed()">保 存</el-button>
      </div>
    </el-dialog>

    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择"
      v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import {
  getEvaluateUserList, //查询查询权限列表
  getEvaluateUserDetailService, //查询用户权限详情
  saveEvaluateUserInfo, // 新增评分权限账户
  delEvaluateUserInfo, // 删除评分权限账户
} from "@/services/supplierMagServices";
import {
  getDeptList, //获取项目部下拉列表
} from "@/services/financeService";
import SelectDialog from "./SelectDialog"; //选择人员弹窗

export default {
  name: "roleSetting",
  components: {
    SelectDialog,
  },
  data() {
    return {
      total: 0, //用户总数
      UsersList: [], //用户列表
      isAddDialogShow: false, //新增用户弹窗显示开关
      isAdd: true, //新增/修改用户标识
      selectDialogVisible: false, //选择用户弹窗可见性
      userRoleSelectedList: [], //选中的用户数组
      deptList: [], //可选项目部列表
      menuRoleCode: "", //授权菜单的roleCode
      ruleForm: {
        pageIndex: 1,
        pageSize: 20,
      },
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "adminUsers",
        canSelectAll: false,
      },
      productAccountArr: [{ typeKey: "", typeValue: "" }], //生产账号
      adminAccountArr: [{ typeKey: "", typeValue: "" }], //管理账号
      productPermissionNames: "",
      dutyPermissionUserNames: "",

      addForm: {
        deptId: "", //项目部
        productPermissionUserIdList: [],
        dutyPermissionUserIdList: [],
        isAdmin: 1,
      },
      addRules: {
        name: [
          { required: true, message: "请输入用户名称" },
          { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" },
        ],
        remark: [{ min: 1, max: 60, message: "备注长度必须介于1到60之间" }],
        type: [{ required: true, message: "请选择用户类型" }],
        // deptCode: [{ required: true, message: "请选择组织" }]
      },
      //按钮权限
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
      },
    };
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  created() {},
  methods: {
    setUserType(val) {
      console.log(val);
      if (val == "wechat") {
        this.addForm.isAdmin = 0;
      }
    },
    //激活时调用
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.ruleForm.pageIndex = 1;
      this.ruleForm.pageSize = 10;
      // this.getUserOneLevelDept();
      this.getAllUsers();
      this.getDeptList();
    },
    /* 获取评价用户列表 */
    getAllUsers() {
      getEvaluateUserList(this.ruleForm).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.total = res.total;
            this.UsersList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    //获取项目部下拉列表数据
    getDeptList() {
      // 获取可供选择的项目部的列表
      getDeptList()
        .then((res) => {
          if (res.code == 10000000) {
            this.deptList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },

    /* 新增一条用户信息 */
    addEvaluateUser() {
      // this.addForm.createUserId = sessionStorage.getItem("currentUserId");
      saveEvaluateUserInfo(this.addForm).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("新增成功", "提示", {
              confirmButtonText: "确定",
            });
            this.isAddDialogShow = false;
            this.addForm.deptId = "";
            this.productPermissionNames = "";
            this.dutyPermissionUserNames = "";
            this.addForm.dutyPermissionUserIdList = [];
            this.addForm.productPermissionUserIdList = [];
            this.getAllUsers();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 添加一条评价用户信息 */
    modifyUser() {
      // this.addForm.updateUserId = sessionStorage.getItem("currentUserId");
      saveEvaluateUserInfo(this.addForm).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("修改成功", "提示");
            this.isAddDialogShow = false;
            this.addForm.deptId = "";
            this.productPermissionNames = "";
            this.dutyPermissionUserNames = "";
            this.addForm.dutyPermissionUserIdList = [];
            this.addForm.productPermissionUserIdList = [];
            this.getAllUsers();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 删除一条评价用户信息 */
    deleteUser(deptId) {
      let reqParam = {
        // userCode: sessionStorage.getItem("userCode"),
        deptId: deptId,
      };
      delEvaluateUserInfo(reqParam).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("删除成功", "提示");
            this.isAddDialogShow = false;
            this.getAllUsers();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.ruleForm.pageIndex = page;
      this.getAllUsers();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.ruleForm.pageSize = rows;
      this.ruleForm.pageIndex = 1;
      this.getAllUsers();
    },
    /* 新增按钮回调 */
    addBtnPressed() {
      this.isAdd = true;
      this.isAddDialogShow = true;
      this.addForm.deptId = "";
      this.productPermissionNames = "";
      this.dutyPermissionUserNames = "";
      this.addForm.dutyPermissionUserIdList = [];
      this.addForm.productPermissionUserIdList = [];
    },
    /* 修改按钮回调 */
    updBtnPressed(row) {
      this.isAdd = false;
      this.isAddDialogShow = true;
      this.addForm.deptId = row.deptId;
      this.projectDeptChange(row.deptId);
    },
    /* 删除按钮回调 */
    delBtnPressed(row) {
      this.$confirm("确定删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // let roles = [];
        // this.userRoleSelectedList.forEach(role => {
        //   roles.push(role.roleId);
        // });
        let deptId = row.deptId;
        this.deleteUser(deptId);
      });
    },
    assignBtnPressed() {
      if (this.userRoleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.userRoleSelectedList[0].id;
        this.$refs.RoleMenuAssignDialog.refreshMenu(this.menuRoleCode);
      }
    },
    accountAssignPressed() {
      if (this.userRoleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.userRoleSelectedList[0].roleCode;
        this.$refs.RoleAccountAssignDialog.refreshAccount(this.menuRoleCode);
      }
    },
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
      this.addForm.deptId = "";
      this.productPermissionNames = "";
      this.dutyPermissionUserNames = "";
      this.addForm.dutyPermissionUserIdList = [];
      this.addForm.productPermissionUserIdList = [];
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate((res) => {
        if (res) {
          if (this.isAdd) {
            this.addEvaluateUser();
          } else {
            this.modifyUser();
          }
        }
      });
    },
    projectDeptChange(val) {
      // 获取该项目部下的评价用户
      let param = {};
      param.deptId = val;
      getEvaluateUserDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            // this.deptList = res.data || [];
            if (res.data) {
              if (
                null != res.data.productPermissionUserList &&
                res.data.productPermissionUserList.length > 0
              ) {
                let productdata = res.data.productPermissionUserList;
                if (res.data.productPermissionUserList.length == 1) {
                  this.productPermissionNames = productdata[0].displayName;
                  this.addForm.productPermissionUserIdList.push(
                    productdata[0].id
                  );
                } else {
                  this.productPermissionNames = productdata[0].displayName;
                  this.addForm.productPermissionUserIdList.push(
                    productdata[0].id
                  );
                  for (let i = 1; i < productdata.length; i++) {
                    this.productPermissionNames =
                      this.productPermissionNames +
                      "," +
                      productdata[i].displayName;
                    this.addForm.productPermissionUserIdList.push(
                      productdata[i].id
                    );
                  }
                }
              }
              if (
                null != res.data.dutyPermissionUserList &&
                res.data.dutyPermissionUserList.length > 0
              ) {
                let productdata = res.data.dutyPermissionUserList;
                if (res.data.dutyPermissionUserList.length == 1) {
                  this.dutyPermissionUserNames = productdata[0].displayName;
                  this.addForm.dutyPermissionUserIdList.push(productdata[0].id);
                } else {
                  this.dutyPermissionUserNames = productdata[0].displayName;
                  this.addForm.dutyPermissionUserIdList.push(productdata[0].id);
                  for (let i = 1; i < productdata.length; i++) {
                    this.dutyPermissionUserNames =
                      this.dutyPermissionUserNames +
                      "," +
                      productdata[i].displayName;
                    this.addForm.dutyPermissionUserIdList.push(
                      productdata[i].id
                    );
                  }
                }
              }
            }
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /* 列代表多选回调 */
    handleSelectionChange(UsersList) {
      // this.userRoleSelectedList = UsersList;
      this.userRoleSelectedList = UsersList ? [UsersList] : [];
    },

    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    /**
     * 新增生产账号
     */
    addClassifyList() {
      // 选择生产部门评价账号
      if (this.addForm.deptId == "") {
        this.$alert("请先选择项目部", "提示");
        return;
      }
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "productUsers",
      };
      this.selectDialogVisible = true;
    },
    selectDialogClose(data) {
      console.log("111 selectDialogClose ----", data);
      this.selectDialogVisible = false;
      if (data.flag) {
        let flag = data.flag;
      } else {
        const dataKey = data.dataKey;
        switch (dataKey) {
          case "adminUsers": //主管部门
            this.addForm.dutyPermissionUserIdList = [];
            if (data.userList && data.userList.length > 0) {
              let productdata = data.userList;
              if (data.userList.length == 1) {
                this.dutyPermissionUserNames = productdata[0].displayName;
                this.addForm.dutyPermissionUserIdList.push(productdata[0].id);
              } else {
                this.dutyPermissionUserNames = productdata[0].displayName;
                this.addForm.dutyPermissionUserIdList.push(productdata[0].id);
                for (let i = 1; i < productdata.length; i++) {
                  this.dutyPermissionUserNames =
                    this.dutyPermissionUserNames +
                    "," +
                    productdata[i].displayName;
                  this.addForm.dutyPermissionUserIdList.push(productdata[i].id);
                }
              }
            }
            break;
          case "productUsers": // 生产部门
            this.addForm.productPermissionUserIdList = [];
            if (data.userList && data.userList.length > 0) {
              let productdata = data.userList;
              if (data.userList.length == 1) {
                this.productPermissionNames = productdata[0].displayName;
                this.addForm.productPermissionUserIdList.push(
                  productdata[0].id
                );
              } else {
                this.productPermissionNames = productdata[0].displayName;
                this.addForm.productPermissionUserIdList.push(
                  productdata[0].id
                );
                for (let i = 1; i < productdata.length; i++) {
                  this.productPermissionNames =
                    this.productPermissionNames +
                    "," +
                    productdata[i].displayName;
                  this.addForm.productPermissionUserIdList.push(
                    productdata[i].id
                  );
                }
              }
            }
            break;

          default:
            break;
        }
      }
    },

    // /**
    //  * 删除一条生产账号
    //  */
    // delClassifyList(index) {
    //   this.productAccountArr.splice(index, 1);
    // },

    /**
     * 新增主管账号
     */
    addadminAccountArr() {
      if (this.addForm.deptId == "") {
        this.$alert("请先选择项目部", "提示");
        return;
      }
      // 选择主管部门评价账号
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "adminUsers",
      };
      this.selectDialogVisible = true;
    },
    /**
     * 删除一条主管账号
     */
    // deladminAccountArr(index) {
    //   this.adminAccountArr.splice(index, 1);
    // },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.roleSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
.time-box {
  //  display: flex;
  // height: 180px;
  overflow-y: auto;
  flex: 1;

  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
}
.left {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}

.right {
  height: 32px;
  line-height: 32px;
  width: 50px;
  text-align: center;
  cursor: pointer;
}

.add {
  background-color: #00cccc;
  border-radius: 2px;
  color: #ecf5ff;
}
</style>
